import { useQuery } from "@tanstack/react-query";
import { useCurrentCompany } from "hooks/auth";
import { StaleTime } from "newui/store/tanstack-base";
import { getProjectTypes } from "../api/project-type-api";
import type { RfxProjectType } from "../types/rfx.types";

export const useRfxProjectTypes = (enabled = true) => {
	const currentCompany = useCurrentCompany();

	return useQuery<RfxProjectType[]>({
		queryKey: ["rfxProjectTypes", currentCompany?.id],
		queryFn: async () => {
			const response = await getProjectTypes();
			return response.data.data;
		},
		enabled: !!currentCompany?.id && enabled,
		staleTime: StaleTime.Long,
	});
};
